var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupporticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_122_40798)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 49.6875C36.35 49.6875 32.5625 45.9 32.5625 41.25V35C32.5625 30.35 36.35 26.5625 41 26.5625C45.65 26.5625 49.4375 30.35 49.4375 35V41.25C49.4375 45.9 45.65 49.6875 41 49.6875ZM41 28.4375C37.3875 28.4375 34.4375 31.375 34.4375 35V41.25C34.4375 44.875 37.3875 47.8125 41 47.8125C44.6125 47.8125 47.5625 44.875 47.5625 41.25V35C47.5625 31.375 44.6125 28.4375 41 28.4375Z",
    fill: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 53.4375C34.275 53.4375 28.8125 47.975 28.8125 41.25V38.75C28.8125 38.2375 29.2375 37.8125 29.75 37.8125C30.2625 37.8125 30.6875 38.2375 30.6875 38.75V41.25C30.6875 46.9375 35.3125 51.5625 41 51.5625C46.6875 51.5625 51.3125 46.9375 51.3125 41.25V38.75C51.3125 38.2375 51.7375 37.8125 52.25 37.8125C52.7625 37.8125 53.1875 38.2375 53.1875 38.75V41.25C53.1875 47.975 47.725 53.4375 41 53.4375Z",
    fill: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2625 35.2876C44.1625 35.2876 44.05 35.2751 43.9375 35.2376C41.925 34.5126 39.7125 34.5126 37.7 35.2376C37.225 35.4126 36.6875 35.1626 36.5125 34.6751C36.3375 34.1876 36.5875 33.6501 37.075 33.4751C39.5 32.6001 42.1625 32.6001 44.5875 33.4751C45.075 33.6501 45.325 34.1876 45.15 34.6751C45.0125 35.0626 44.65 35.2876 44.2625 35.2876Z",
    fill: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.125 39.0376C43.05 39.0376 42.9625 39.0251 42.875 39.0001C41.5375 38.6376 40.125 38.6376 38.7875 39.0001C38.275 39.1376 37.775 38.8376 37.6375 38.3376C37.5 37.8376 37.8 37.3251 38.3 37.1876C39.9625 36.7376 41.7125 36.7376 43.375 37.1876C43.875 37.3251 44.175 37.8376 44.0375 38.3376C43.9125 38.7751 43.5375 39.0376 43.125 39.0376Z",
    fill: "#EE1C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_122_40798",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_40798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_122_40798",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupporticon);
export default __webpack_public_path__ + "static/media/supporticon.1fefd4d29ad851188827e58aa2ff0543.svg";
export { ForwardRef as ReactComponent };